import Product from './Product.js';

export default class ProductList {
  constructor(data) {
    this._data = data;
  }

  /**
   * @return {Product[]}
   */
  get items() {
    if (!Array.isArray(this._data)) {
      throw new Error('Product data must be an array.');
    }
    return this._data.map(itemData => new Product(itemData));
  }

  /**
   * @param {function(Product): boolean} predicate
   * @return {boolean}
   */
  hasItemByPredicate(predicate) {
    return this.items.some(predicate);
  }

  /**
   * @param {function(Product): boolean} predicate
   * @return {?Product}
   */
  getItemByPredicate(predicate) {
    return this.items.find(predicate);
  }

  /**
   * @param {function(Product): boolean} predicate
   * @return {Product[]}
   */
  getFilteredItems(predicate) {
    return this.items.filter(predicate);
  }

  /**
   * @return {?Product}
   */
  get singleItem() {
    if (this.items.length !== 1) {
      return null;
    }
    return this.items[0];
  }

  /**
   * @return {boolean}
   */
  get hasItems() {
    return this.items.length > 0;
  }
}
